import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Header } from "./Header";
import { HeroSection } from "./HeroSection";
import { FeaturesSection } from "./FeaturesSection";
import { ProblemSolutionSection } from "./ProblemSolutionSection";
import { Footer } from "./Footer";

export const LandingPage = ({ 
  onLogin, 
  onSignup, 
  onExplore,
  onNavigateToDashboard 
}) => {
  const { user, isAuthenticated } = useAuth();
  
  const handleLearnMore = () => {
    const featuresElement = document.getElementById('features');
    if (featuresElement) {
      featuresElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleJoinCommunity = () => {
    if (onSignup) {
      onSignup();
    }
  };

  const handleStartExploring = () => {
    if (isAuthenticated && onExplore) {
      onExplore();
    } else if (onSignup) {
      // If not authenticated, prompt for signup first
      onSignup();
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header 
        isAuthenticated={isAuthenticated}
        onLogin={onLogin}
        onSignup={onSignup}
        onNavigateToDashboard={onNavigateToDashboard}
      />
      
      <HeroSection 
        onExplore={handleStartExploring}
        onLearnMore={handleLearnMore}
      />
      
      <FeaturesSection />
      
      <ProblemSolutionSection 
        onJoinCommunity={handleJoinCommunity}
      />
      
      <section id="community" className="section-mobile bg-gray-50">
        <div className="max-w-7xl mx-auto container-mobile text-center">
          <h2 className="mobile-heading-2 section-gap-mobile">
            Ready to Travel with Confidence?
          </h2>
          <p className="mobile-body-text section-gap-mobile max-w-2xl mx-auto">
            Join thousands of women travelers sharing real experiences and building a safer world for female exploration.
          </p>
          <div className="hero-buttons-mobile justify-center">
            <button 
              onClick={handleStartExploring}
              className="btn-mobile bg-red-400 text-white hover:bg-red-500 shadow-lg text-base font-semibold inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-lg px-10 text-lg transform hover:scale-105 duration-200"
            >
              {isAuthenticated ? 'Start Your Safe Journey' : 'Sign Up & Start Exploring'}
            </button>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};